export const SYMBOL_CONFIG: Record<string, { binancePair: string; geckoId: string }> = {
  BTC: { binancePair: 'BTCUSDT', geckoId: 'bitcoin' },
  ETH: { binancePair: 'ETHUSDT', geckoId: 'ethereum' },
  SOL: { binancePair: 'SOLUSDT', geckoId: 'solana' },
  XRP: { binancePair: 'XRPUSDT', geckoId: 'ripple' },
  BNB: { binancePair: 'BNBUSDT', geckoId: 'binancecoin' },
};

export const SUPPORTED_SYMBOLS = Object.keys(SYMBOL_CONFIG);

export const CORE_GECKO_IDS = Array.from(
  new Set(Object.values(SYMBOL_CONFIG).map((config) => config.geckoId))
);
